import type { AccessibleModule, PagePermission, Vendor } from "@shared/types";
import { noAuthAxios } from ".";

export interface AccessScopeElements {
  actions?: string[];
  pages?: string[] | PagePermission[];
  menuGroups?: AccessibleModule[];
}

export interface TokenResponse {
  accessToken?: string;
  vendor?: Vendor;
  idToken?: string;
  refreshToken?: string;
  profileName?: string;
  role?: string;
  /** The signed-in person's Salesforce Contact ID; stays the actor through impersonation. */
  contactId?: string;
  accountType?: string;
  accessibleFeatures?: string;
  accessScopeElements?: AccessScopeElements;
  isBccUser: boolean;
}

const OAUTH_BASE_URL = "/api/v1/services/bc-services/oauth";

export const getAuthorizeUrl = async (): Promise<string> => {
  const url = `${OAUTH_BASE_URL}/authorize`;
  const response = await noAuthAxios.get(url);
  return response.data.data;
};

export const getOAuthToken = async (code: string) => {
  const url = `${OAUTH_BASE_URL}/token`;
  const config = { params: { code } };
  const response = await noAuthAxios.get<{ data: TokenResponse }>(url, config);
  return response.data.data;
};

export const getLogoutUrl = async (): Promise<string> => {
  const url = `${OAUTH_BASE_URL}/logout`;
  const response = await noAuthAxios.get(url);
  return response.data.data;
};

export const refreshToken = async (token: string) => {
  const url = `${OAUTH_BASE_URL}/refresh`;
  const config = { params: { refresh_token: token } };
  const response = await noAuthAxios.get<{ data: TokenResponse }>(url, config);
  return response.data.data;
};
